export default "__VITE_ASSET__Y3Vf4TvT__"